import React from 'react';
import type { ReactNode } from 'react';

import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { Divider } from 'primereact/divider';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagic } from '@fortawesome/pro-solid-svg-icons';

import { Button, FlexBox, Modal, Text } from '@eltoro-ui/components';

import CustomIcons from 'assets/icons';

import cross from 'assets/Images/cross.png';

import type { TRootState } from 'types';

import './ContactEnrichmentInformationModal.scss';

type ContactEnrichmentInformationModalProps = {
  potentialEnriched?: string | ReactNode;
  onClose: () => void;
};

export default function ContactEnrichmentInformationModal({
  potentialEnriched,
  onClose,
}: ContactEnrichmentInformationModalProps) {
  const history = useHistory();
  const { userData } = useSelector((state: TRootState) => state.userReducer);

  return (
    <Modal className="ContactEnrichmentInformationModal">
      <img
        src={cross}
        onClick={onClose}
        alt="cross"
        className="PersonalInfoForm__cross"
        role="presentation"
      />
      <FlexBox flexDirection="column" alignItems="center" gap="2rem">
        <FlexBox flexDirection="column" gap="1rem">
          <CustomIcons name="contact_enrichment_info" fontSize={95} />
          <FlexBox flexDirection="column" gap="0.5rem">
            <Text
              on="white"
              textAlign="center"
              weight="bold"
              UNSAFE_style={{ color: '#262626', fontSize: 16 }}
            >
              What is contact enrichment?
            </Text>
            <Text
              on="white"
              textAlign="center"
              UNSAFE_style={{ color: '#757575', fontSize: 16, maxWidth: 530, lineHeight: 1.5 }}
            >
              Sending digital ads and receiving in-market activity alerts depends heavily on a
              contacts' home address. Beewo's 'Contact Enrichment ' (premium feature) automatically
              identifies a contact's missing addresses upon upload when either an email address or
              phone number is provided. You'll see an 'enrichment' icon if the home address is
              found. Beewo will not share back the address.
            </Text>
          </FlexBox>
        </FlexBox>
        {userData?.sub_name === 'premium' ? (
          <Button kind="default" size="l" weight="bold" onClick={onClose}>
            Close
          </Button>
        ) : (
          <FlexBox flexDirection="column" alignItems="center" gap="1rem">
            <Divider />
            <FlexBox flexDirection="column" alignItems="center" gap="2rem">
              <span className="potential-enriched">{potentialEnriched}</span>
              <Button
                key="upgrade"
                UNSAFE_className="upgrade-button"
                size="l"
                weight="bold"
                onClick={() => history.push('/profile/billing')}
                iconLeft={<FontAwesomeIcon icon={faMagic} />}
              >
                Upgrade
              </Button>
            </FlexBox>
          </FlexBox>
        )}
      </FlexBox>
    </Modal>
  );
}
